import React from "react";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";

interface Props {
	number?: string;
	orderAt?: string;
}

const OrderDetailsHeader = ({ number, orderAt }: Props) => {
	const { t } = useTranslation();

	return (
		<div className="mb-3 d-flex flex-column">
			<h1 className="mb-2">{t("common.word.details")}</h1>
			{number && <small data-testid="order-details-header-order-number">{`#${number}`}</small>}
			{orderAt && <small data-testid="order-details-header-order-date">{FormatDate(orderAt)}</small>}
		</div>
	);
};

export default OrderDetailsHeader;
